/**
 * How long a toast stays on screen when the caller does not name a duration.
 *
 * Dependency-free on purpose: the "[frontend] Tests" step runs without an npm install, so the
 * arithmetic and its bounds live here rather than in `toast-helper.tsx`, which pulls in React and
 * next/image. Turning markup into the text this measures is that file's job — it needs React.
 */

export const MIN_AUTO_CLOSE_MS = 3000;

/**
 * A toast is glanced at, not read. Past a few seconds a longer one is not being read either — it is
 * just in the way. `showErrorToast` can also hand over a stringified API error whose word count
 * would otherwise park it on screen for minutes.
 */
export const MAX_AUTO_CLOSE_MS = 8000;

/** Below prose speed on purpose: a toast is scanned, not read. */
const WORDS_PER_MINUTE = 150;

export function calculateReadingTime(text: string): number {
    const trimmed = text.trim();
    // '' splits to [''] — one phantom word, which the floor used to hide.
    const words = trimmed.length === 0 ? 0 : trimmed.split(/\s+/).length;
    const milliseconds = (words / WORDS_PER_MINUTE) * 60 * 1000;

    return Math.round(Math.min(Math.max(milliseconds, MIN_AUTO_CLOSE_MS), MAX_AUTO_CLOSE_MS));
}
